import { Button, Collapse, Form, Layout, Space } from "antd";
import { STORE_FOLDING_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { postData } from "apiServices/common";
import HandleNotification from "common/Notification";
import AppPageHeader from "common/PageHeader";
import InventoryLayOutCommon from "components/InventoryFabric/LayOut/InventoryLayOutCommon";
import { FoldingContext } from "context/FoldingContext/FoldingContextProvider";
import { useContext, useState } from "react";
import { useNavigate } from "react-router";
import { FOLDING_CREATE_PERMISSION } from "routes/permissions";
import { hasPermission, isArrayAndHasValue } from "utils/functions";
import FoldingDetails from "../FoldingDetails/FoldingDetails";
import CuttingForm from "./FoldingForm";

const { Content } = Layout;
const { Panel } = Collapse;

const CreateFoldingEntry = (props) => {
  // Contexts
  const { foldingTableData, subContractStatus } = useContext(FoldingContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Antd
  const [form] = Form.useForm();

  // Router
  const navigate = useNavigate();

  const goBackToFoldingRoute = () => {
    navigate("/production/folding");
  };

  const extra = (
    <Space>
      <Button size="small" onClick={goBackToFoldingRoute}>
        Back
      </Button>
      <Button
        htmlType="submit"
        type="primary"
        size="small"
        onClick={() => form.submit()}
        disabled={!hasPermission([FOLDING_CREATE_PERMISSION]) || isSubmitting}
      >
        {hasPermission([FOLDING_CREATE_PERMISSION])
          ? "Submit"
          : "No Permission"}
      </Button>
      <Button size="small" htmlType="submit" onClick={() => form.resetFields()}>
        {" "}
        Reset
      </Button>
    </Space>
  );

  const onFinish = async (values) => {
    setIsSubmitting(true);
    const foldingProducts =
      isArrayAndHasValue(foldingTableData) &&
      foldingTableData?.map((item) => {
        return {
          folding_product_id:
            item?.folding_products?.folding_product_id || null,
          history_id: item?.folding_products?.history_id || null,
          internal_po: item?.internal_po,
          original_po: item?.original_po,
          po_map_id: item?.po_map_id || null,
          color_id: item?.color?.id || null,
          sub_style_id: item?.sub_style_info?.id || null,
          size_id: item?.size?.id || null,
          folding_piece: item?.folding_products?.folding_piece,
          remain_piece: item?.folding_products?.remain_piece,
          folding_day: item?.folding_products?.folding_day,
          transaction_no_per_day:
            item?.folding_products?.transaction_no_per_day,
        };
      });

    const query = `${STORE_FOLDING_ENDPOINT}`;
    const bodyData = {
      sales_contract_id: values?.sales_contract_id || null,
      buying_office_id: values?.buying_office_id || null,
      style_id: values?.style_id || null,
      folding_date: values?.folding_date,
      folding_products: foldingProducts,
      buyer_id: values?.buyer_id || null,
      use_both_style_po: values?.use_both_style_po,
      subcontract_status: subContractStatus,
      sub_contract_factory_id: values?.factory_id || null,
    };

    const response = await postData(query, bodyData);

    if (response && response?.code === 200) {
      HandleNotification(
        "success",
        "bottomRight",
        "Folding created successfully",
        null,
      );
    } else {
      setIsSubmitting(false);
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }
  };

  return (
    <>
      <InventoryLayOutCommon>
        <AppPageHeader title="Folding Entry" extra={extra} />
        <Content className="item-details">
          <Collapse defaultActiveKey={["1"]} style={{ marginTop: 15 }}>
            <Panel header={<b>Order Details</b>} key="1">
              <Form layout="vertical" onFinish={onFinish} form={form}>
                <CuttingForm form={form} setIsSubmitting={setIsSubmitting} />
              </Form>
            </Panel>
          </Collapse>
          {/* Folding Details Table */}
          <FoldingDetails />
        </Content>
      </InventoryLayOutCommon>
    </>
  );
};

export default CreateFoldingEntry;
